import React from 'react'
import { SidebarAccessorType } from 'Hooks/use-sidebar'
import { ToolbarAccessorType } from 'Hooks/use-toolbar'
import { Studio } from 'Core/Studio'
import { useAppProps } from 'antd/lib/app/context'
import { WorkbenchLayoutContainer } from 'Layouts/Workbench/WorkbenchLayoutContainer'
import { NotificationBadgeAccessorType } from 'Hooks/use-notification-badge'
import { ModalContainerAccessorType } from 'Hooks/use-modal-container'
import { TaskContextType } from 'Contexts/TaskContext'

export type SidebarItem = {
    id: string
    title: string
    icon: React.FC<{ color: string }>
    element: React.ReactElement
    destroyOnClose?: boolean
    isElementHighlighted?: boolean
}

export type NotificationBadge = {
    id: string
}

export type Divider = { isDivider: true }

export type Notifier = useAppProps

export type DropdownOption = {
    label: string
    value: string
}

export type ToolbarActionType = {
    id: string
    title: string
    label?: React.ReactElement
    icon?: React.FC<{ color: string }> | React.FC
    onClick?: () => void | Promise<void>
    onChange?: (value: string) => void | Promise<void>
    options?: DropdownOption[]
    type?: string
    color?: 'primary' | 'default' | 'danger'
    isCollapsed?: boolean
    disabled?: boolean | (() => boolean)
    tooltip?: string
    children?: {
        id: string
        title: string
        onClick: () => void | Promise<void>
        disabled?: boolean
        icon?: React.FC<{ color: string }> | React.FC
        iconColor?: string | undefined
    }[]
}

export type CustomToolbarActionType = {
    id: string
    component: React.ReactElement
}

export type WorkbenchUiAccessorType = {
    leftSidebar: SidebarAccessorType
    rightSidebar: SidebarAccessorType
    replaceMainContent: (element: React.ReactElement) => void
    toolbar: ToolbarAccessorType
    setInitialized: (initialized: boolean) => void
    notifier: Notifier
    updateUI: () => void
    notificationBadge: NotificationBadgeAccessorType
    modalContainer: ModalContainerAccessorType
    setTaskContextGetter: (taskContextGetter: { getTaskContext: () => TaskContextType }) => void
    setShouldCloseOppositeSidebar: (enabled: boolean) => void
}

export type ExpertsCommentsType = {
    outputContainerId?: string
    message: string
    panelHeader: string
    rejectionReasons?: string[]
}

export class Workbench {
    element: React.ReactElement
    workbenchUiAccessor?: WorkbenchUiAccessorType
    uiUpdateQueue: ((accessor: WorkbenchUiAccessorType) => void)[] = []

    constructor(studio: Studio) {
        this.element = React.createElement(WorkbenchLayoutContainer, {
            setAccessor: this.setWorkbenchUiAccessor,
            taskConfig: studio.taskConfig,
        })
    }

    setWorkbenchUiAccessor = (accessor: WorkbenchUiAccessorType) => {
        this.workbenchUiAccessor = accessor
        if (this.uiUpdateQueue.length) {
            this.uiUpdateQueue.forEach(callback => {
                callback(accessor)
            })
            this.uiUpdateQueue = []
        }
    }

    enqueueUiUpdate(callback: (accessor: WorkbenchUiAccessorType) => void) {
        if (this.workbenchUiAccessor) {
            callback(this.workbenchUiAccessor)
        } else {
            this.uiUpdateQueue.push(callback)
        }
    }
}
